/**
 * TODO - preamble
 *
 * propTypes.js
 * Useful for runtime type/shape checking
 */
import * as propTypes from 'prop-types';
import { Segments, VerificationSteps } from './runtimeTypes';

const intlShape = propTypes.shape({
    locale: propTypes.string.isRequired,
    messages: propTypes.object.isRequired,
});

export const DatabaseId = propTypes.string;

export const collectStudentPersonalInfoResponse = propTypes.shape({
    verificationId: DatabaseId,
    currentStep: propTypes.oneOf(VerificationSteps),
    currentStepFields: propTypes.shape({
        required: propTypes.arrayOf(propTypes.string),
    }),
    rewardCode: propTypes.string,
});

export const studentPersonalInfoViewModelShape = propTypes.shape({
    verificationId: DatabaseId.isRequired,
    firstName: propTypes.string.isRequired,
    lastName: propTypes.string.isRequired,
    email: propTypes.string.isRequired,
    birthDate: propTypes.string.isRequired, // ISO-8601 'YYYY-MM-DD' TODO - better prop type to check this value?
    organization: propTypes.shape({
        id: propTypes.number.isRequired,
        name: propTypes.string.isRequired,
    }),
});

export const seniorPersonalInfoViewModelShape = propTypes.shape({
    verificationId: DatabaseId.isRequired,
    firstName: propTypes.string.isRequired,
    lastName: propTypes.string.isRequired,
    email: propTypes.string.isRequired,
    birthDate: propTypes.string.isRequired, // ISO-8601 'YYYY-MM-DD' TODO - better prop type to check this value?
    postalCode: propTypes.string.isRequired,
});

export const activeMilitaryPersonalInfoViewModelShape = propTypes.shape({
    verificationId: DatabaseId.isRequired,
    firstName: propTypes.string.isRequired,
    lastName: propTypes.string.isRequired,
    email: propTypes.string.isRequired,
    birthDate: propTypes.string.isRequired, // ISO-8601 'YYYY-MM-DD' TODO - better prop type to check this value?
    organization: propTypes.shape({
        id: propTypes.number.isRequired,
        name: propTypes.string.isRequired,
    }),
});

export const inactiveMilitaryPersonalInfoViewModelShape = propTypes.shape({
    verificationId: DatabaseId.isRequired,
    firstName: propTypes.string.isRequired,
    lastName: propTypes.string.isRequired,
    email: propTypes.string.isRequired,
    birthDate: propTypes.string.isRequired, // ISO-8601 'YYYY-MM-DD' TODO - better prop type to check this value?
    organization: propTypes.shape({
        id: propTypes.number.isRequired,
        name: propTypes.string.isRequired,
    }),
    dischargeDate: propTypes.string.isRequired, // ISO-8601 'YYYY-MM-DD' TODO - better prop type to check this value?
});

export const docUploadVerificationResponse = propTypes.object; // TODO
export const docUploadViewModel = propTypes.object; // TODO
export const successResponseShape = propTypes.shape({
    verificationId: DatabaseId.isRequired,
    currentStep: propTypes.string.isRequired,
    rewardCode: propTypes.string.isRequired,
});
export const ErrorResponse = propTypes.object; // TODO
export const docReviewLimitExceededResponse = propTypes.object; // TODO

export const verificationResponseShape = propTypes.oneOfType([
    collectStudentPersonalInfoResponse,
    successResponseShape,
    // TODO
]);

export const verificationRequestShape = propTypes.oneOfType([
    studentPersonalInfoViewModelShape.isRequired,
    activeMilitaryPersonalInfoViewModelShape.isRequired,
    inactiveMilitaryPersonalInfoViewModelShape.isRequired,
]);

export const programIdShape = propTypes.string;


export const updateViewModelShape = propTypes.func;

const VerificationServiceIsLoadingShape = propTypes.shape({
    isLoading: propTypes.bool.isRequired,
});

const VerificationServiceIsErroredShape = propTypes.shape({
    isLoading: propTypes.bool.isRequired,
    isErrored: propTypes.bool.isRequired,
});

export const VerificationServiceIsLoadedShape = propTypes.shape({
    isLoading: propTypes.bool.isRequired,
    isErrored: propTypes.bool.isRequired,
    verificationRequest: verificationRequestShape.isRequired,
    verificationResponse: verificationResponseShape,
    fetchNewVerificationRequest: propTypes.func.isRequired,
    updateViewModel: updateViewModelShape.isRequired,
    fieldValidationErrors: propTypes.object.isRequired,
    viewModel: propTypes.object.isRequired,
    programTheme: propTypes.object.isRequired,
    previousViewModel: propTypes.object.isRequired,
    previousVerificationResponse: verificationResponseShape,
    programId: propTypes.string.isRequired,
    updateFieldValidationErrors: propTypes.func.isRequired,
    submitStep: propTypes.func.isRequired,
});

export const VerificationServiceShape = propTypes.oneOfType([
    VerificationServiceIsLoadingShape,
    VerificationServiceIsErroredShape,
    VerificationServiceIsLoadedShape,
]);

export const segmentShape = propTypes.oneOf(Segments);

export const FormSelectChoiceShape = propTypes.shape({
    value: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired,
    label: propTypes.string.isRequired,
});

export const OrganizationShape = propTypes.shape({
    id: propTypes.number.isRequired,
    name: propTypes.string.isRequired,
});
